import {Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import React from 'react'

import {ConfirmModal} from './ConfirmModal/ConfirmModal'
import {useOptimizeRouteConfirmModal} from './hooks'
import * as classes from './OptimizeRouteConfirmModal.classes'
import type {Props} from './types'

export function OptimizeRouteConfirmModal(props: Props): React.ReactElement {
  const {isActive, setActive} = props
  const {optimizationState, onDecline, onAccept} = useOptimizeRouteConfirmModal(setActive)
  const i18n = useI18n()

  return (
    <ConfirmModal
      isPending={optimizationState === 'pending'}
      locale={{
        title: i18n('cargo.create.rout-change.optimize_route-question', 'Оптимизировать\nмаршрут?'),
        submit:
          optimizationState === 'pending'
            ? i18n('cargo.create.rout-change.optimization', 'Оптимизация...')
            : i18n('cargo.create.rout-change.optimize', 'Оптимизировать'),
      }}
      ModalProps={modalProps}
      onCancel={onDecline}
      onSubmit={onAccept}
      open={isActive}
    >
      <Typography className={classes.body} variant="caption1">
        {i18n('cargo.create.rout-change.optimization_cannot_be_undone', 'Оптимизацию нельзя будет отменить')}
      </Typography>
    </ConfirmModal>
  )
}

const modalProps = {
  className: classes.paper,
}
